export default __webpack_public_path__ + "static/media/ptx2.79bfc9d2.jpg";